import { object, string } from 'yup';
import { ValidationSchema } from 'enums/CreateBrandModalEnums';
interface CategoryOptions {
  value: string;
  label: string;
}
export const options: CategoryOptions[] = [
  {
    value: 'food',
    label: 'Food',
  },
  {
    value: 'beverage',
    label: 'Beverage',
  },
];

export const validationSchema = object({
  brandName: string().required(ValidationSchema.ERROR_MESSAGE),
  category: string().required(ValidationSchema.ERROR_MESSAGE),
});
